import { CSSProperties } from 'react'
import clsx from 'clsx'

import styles from './_.module.css'

interface Props {
  title?: JSX.Element | string
  description?: JSX.Element | string | null
  background: string
  backgroundPosition?: string
  textColorVariable: string
  backgroundImage?: string
  footerComponent?: JSX.Element
}

const defaultDescription =
  'The Internet is Cluttered with Content about Marketing. Here’s your guide to the world of content creation from the people who live and breathe content.'

const CategoryHero = ({
  background,
  backgroundPosition = 'right top',
  textColorVariable,
  title = 'Peppercontent Blog',
  description,
  backgroundImage,
  footerComponent
}: Props) => {
  return (
    <section
      className={clsx(
        'relative  | py-12 px-8 lg:py-18',
        styles.categoryHeroContainer
      )}
      style={
        {
          background,
          color: `var(--${textColorVariable})`,
          '--bg-image': `url(${backgroundImage})`,
          '--bg-position': backgroundPosition
        } as CSSProperties
      }
    >
      <div className="max-desktop-width  |  mx-auto">
        <h1 className={clsx('font-bold |  mb-4', styles.title)}>{title}</h1>
        <p className="text-paragraph-3  |  max-w-xl  |  mb-6">
          {description || defaultDescription}
        </p>

        {footerComponent && <div className="mt-10">{footerComponent}</div>}
      </div>
    </section>
  )
}

export default CategoryHero
